import { render, staticRenderFns } from "./AppointmentsItemUpcomingView.vue?vue&type=template&id=1df50728&scoped=true&"
import script from "./AppointmentsItemUpcomingView.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsItemUpcomingView.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentsItemUpcomingView.vue?vue&type=style&index=0&id=1df50728&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df50728",
  null
  
)

export default component.exports